import React from 'react';
import Card from './Card';

const Project = ({ name, description, technologies, url }) => (
    <Card url={url}>
        <div>
            <p><strong>{name}</strong></p>
            <p><strong>Technologies: </strong>{technologies}</p>
            <p><strong>Description: </strong>{description}</p>
        </div>
    </Card>
);

export default Project;